import e from "react";
import r from "styled-components";
import o from "prop-types";

function t() {
  return (t = Object.assign || function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var o = arguments[r];

      for (var t in o) {
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function n(e, r) {
  if (null == e) return {};

  var o,
      t,
      n = function (e, r) {
    if (null == e) return {};
    var o,
        t,
        n = {},
        i = Object.keys(e);

    for (t = 0; t < i.length; t++) {
      o = i[t], r.indexOf(o) >= 0 || (n[o] = e[o]);
    }

    return n;
  }(e, r);

  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);

    for (t = 0; t < i.length; t++) {
      o = i[t], r.indexOf(o) >= 0 || Object.prototype.propertyIsEnumerable.call(e, o) && (n[o] = e[o]);
    }
  }

  return n;
}

var i = 16,
    a = function a(e) {
  return {
    number: parseFloat(e),
    units: String(e).replace(/^[\d.-]+/, "")
  };
},
    l = function l() {
  for (var e = "", r = 0; r < arguments.length; ++r) {
    var o = r < 0 || arguments.length <= r ? void 0 : arguments[r];
    "" !== e && (e += " ");
    var t = a(o);
    "rem" !== t.units ? e += t.number / i : e += t.number, 0 != t.number && (e += "rem");
  }

  return e;
};

function c(e, r, o) {
  return r in e ? Object.defineProperty(e, r, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = o, e;
}

function s(e, r) {
  var o = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(e);
    r && (t = t.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), o.push.apply(o, t);
  }

  return o;
}

function u(e) {
  for (var r = 1; r < arguments.length; r++) {
    var o = null != arguments[r] ? arguments[r] : {};
    r % 2 ? s(o, !0).forEach(function (r) {
      c(e, r, o[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : s(o).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(o, r));
    });
  }

  return e;
}

var d = function d(e) {
  return {
    number: parseFloat(e),
    units: String(e).replace(/^[\d.-]+/, "")
  };
},
    b = function b() {
  for (var e = "", r = 0; r < arguments.length; ++r) {
    var o = r < 0 || arguments.length <= r ? void 0 : arguments[r];
    "" !== e && (e += " ");
    var t = d(o);
    "rem" !== t.units ? e += t.number / 16 : e += t.number, 0 != t.number && (e += "rem");
  }

  return e;
},
    f = {
  black: "#000000",
  white: "#ffffff",
  red: "#d52b1e",
  charcoal: "#454545",
  green: "#00ac3e",
  blue: "#0088ce",
  yellow: "#ffbc3d",
  orange: "#ed7000",
  coolGray1: "#f6f6f6",
  coolGray3: "#d8dada",
  coolGray6: "#747676",
  coolGray10: "#333333",
  grayLight: "#d8dada"
},
    m = u({}, f, {}, {
  textColor: f.charcoal,
  textColorSuccess: f.white,
  textColorInfo: f.white,
  textColorWarning: f.charcoal,
  textColorError: f.white
}),
    h = {
  fontFamily: '"BrandFont-Text", Helvetica, Arial, sans-serif',
  monospace: '"SFMono-Regular", "RobotoMono-Regular", monospace',
  sans: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  serif: "serif",
  iconFontUrl: "https://respframework.verizon.com/fonts/verizon-icons/fonts.css",
  iconFont: "verizon-icons"
},
    g = {
  light: 300,
  normal: 400,
  medium: 500,
  bold: 700
},
    p = u({}, h, {}, {
  fontColor: m.black,
  fontColorAlt: m.white,
  fontSize: b(16)
}, {
  fontWeights: g,
  fontHeader: h.fontFamily,
  fontBody: h.sans,
  fontWeight: g
}),
    y = u({
  name: "Verizon Theme"
}, m, {}, p, {}, {
  primary: m.black,
  secondary: m.white,
  accent: m.red,
  background: m.white,
  backgroundColorDisabled: m.coolGray3,
  success: m.green,
  info: m.blue,
  warning: m.yellow,
  error: m.orange,
  disabled: m.coolGray3,
  textColorSuccess: m.white,
  textColorInfo: m.white,
  textColorWarning: m.black,
  textColorError: m.black,
  textColorDisabled: m.white,
  borderWidth: b(1),
  borderStyle: "solid",
  borderColor: m.coolGray3,
  border: "".concat(b(1), " solid ").concat(m.coolGray3),
  borderColorDisabled: m.coolGray3,
  linkColor: m.black,
  linkColorHover: m.blue,
  linkColorActive: m.blue,
  linkDecoration: "underline",
  transitionDuration: "0.2s",
  hrPrimary: "".concat(b(4), " solid ").concat(m.charcoal),
  hrSecondary: "".concat(b(1), " solid ").concat(m.charcoal),
  hrTertiary: "".concat(b(1), " solid ").concat(m.coolGray3)
}),
    v = {
  currentSlide: o.number,
  activeSlide: o.number.isRequired,
  selectedSlide: o.number,
  id: o.string,
  uniqueId: o.string.isRequired,
  ariaLabel: o.string,
  isSlideDark: o.bool,
  inverted: o.bool,
  slideCount: o.number.isRequired,
  goToSlide: o.func.isRequired,
  theme: o.object
},
    k = {
  isSlideDark: !1,
  inverted: !1,
  theme: y
},
    S = r.ul.withConfig({
  displayName: "CarouselBars__StyledSwiperList",
  componentId: "hsj28z-0"
})(["display:flex;align-items:center;justify-content:space-between;"]),
    w = r.li.withConfig({
  displayName: "CarouselBars__StyledSwiperDot",
  componentId: "hsj28z-1"
})(["position:relative;display:block;width:", ";padding-top:", ";padding-bottom:", ";margin-right:", ";cursor:pointer;&:active,&:hover{outline:none;}&::after{content:'';position:absolute;height:", ";bottom:0%;left:0;right:0;background-color:", ";transition:height 250ms,background-color 250ms;}&:last-child{margin-right:0;}&:hover,&:focus{&::after{height:", ";transition:height 250ms,background-color 250ms;}}", " ", " ", ";"], l(24), l(8), l(8), l(4), l(1), function (e) {
  return e.theme.coolGray6;
}, l(4), function (e) {
  var r = e.active,
      o = e.theme;
  return r && "\n      &::after {\n          height: ".concat(l(4), ";\n          background-color: ").concat(o.black, ";\n          transition: height 250ms, background-color 250ms;\n      }\n  ");
}, function (e) {
  var r = e.active,
      o = e.inverted,
      t = e.isSlideDark,
      n = e.theme;
  return !r && (t || o) && "\n      &::after {\n          background-color: ".concat(n.coolGray3, ";\n          transition: height 250ms, background-color 250ms;\n      }\n  ");
}, function (e) {
  var r = e.active,
      o = e.isSlideDark,
      t = e.inverted,
      n = e.theme;
  return r && (o || t) && "\n      &::after {\n          height: ".concat(l(4), ";\n          background-color: ").concat(n.white, ";\n          transition: height 250ms, background-color 250ms;\n      }\n  ");
}),
    C = function C(r) {
  var o = r.slideCount,
      i = r.currentSlide,
      a = r.selectedSlide,
      l = r.activeSlide,
      c = r.isSlideDark,
      s = r.inverted,
      u = (r.id, r.uniqueId),
      d = r.goToSlide,
      b = r.ariaLabel,
      f = r.theme,
      m = n(r, ["slideCount", "currentSlide", "selectedSlide", "activeSlide", "isSlideDark", "inverted", "id", "uniqueId", "goToSlide", "ariaLabel", "theme"]);
  return a = l || a, e.createElement(S, t({
    "aria-label": b,
    "aria-controls": u
  }, m), Array.from({
    length: o
  }).map(function (r, o) {
    return e.createElement(w, {
      key: o + 1,
      active: (a || i) === o + 1,
      "data-index": o + 1,
      "aria-selected": (a || i) === o + 1 || null,
      isSlideDark: s || c,
      onClick: function onClick(e) {
        return function (e, r) {
          d(r), "click" === e.type && e.target.blur();
        }(e, o + 1);
      },
      onKeyPress: function onKeyPress(e) {
        return "Enter" === e.key || " " === e.key || "Tab" === e.key ? d(o + 1) : null;
      },
      "aria-label": "Go to slide ".concat(o + 1),
      theme: f,
      tabIndex: 0,
      role: "option"
    });
  }));
};

C.propTypes = v, C.defaultProps = k;
export { C as CarouselBars };